import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import AwpSpinner from '@components/Common/AwpSpinner';
import { Button, Row, Col, Card, Form, Alert } from 'react-bootstrap';
import Authorize from '@awp/components/Authorize';
import { Permissions } from '@awp/constants';
import { FROST_PROBE_CONFIG, SENSOR_PLACEMENT_CONFIG, SNOW_POLE_CONFIG } from '@awp/constants';
import { isValueEmpty, isObjectEmpty } from '@awp/helpers/utilsReact';

import PlacementTemplate from './PlacementTemplate';
import {
  getCurrentPlacementTemplatePacket,
  getNewTotId,
  isLoading,
  hasLoaded,
  isEditing,
  setEditing,
  setTemplate,
  setOrignTemplate,
  setTotId,
  setData,
} from '@stores/placementTemplatePacketSlice';

const blankColumn = {
  maxWidth: '2rem',
};
const PlacementTemplateList = ({ sensorTypeData }) => {
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const loaded = useSelector(hasLoaded);
  const inEditing = useSelector(isEditing);
  const newTotId = useSelector(getNewTotId);
  const placementTemplatePacket = useSelector(getCurrentPlacementTemplatePacket);

  const [createModal, setCreateModal] = useState(false);

  const isOtherEditing = () => {
    return !isValueEmpty(inEditing);
  };

  const createNewTemplate = () => {
    let newTots = [];
    let _tot = { ...SENSOR_PLACEMENT_CONFIG.NEW_TEMPLATE_OBSERVATION_TYPE };
    _tot.Id = newTotId;
    newTots.push(_tot);
    dispatch(setTotId(newTotId + 1));

    let newPlacementTemplate = {
      Id: SENSOR_PLACEMENT_CONFIG.TPL_ID,
      SensorTypeId: sensorTypeData.Id,
      SensorTypeName: sensorTypeData.Name,
      Name: '',
      TemplateObservationTypes: [...newTots],
    };

    dispatch(setTemplate(newPlacementTemplate));
    dispatch(setEditing(SENSOR_PLACEMENT_CONFIG.TEMPLATE_TAG + newPlacementTemplate.Id));
    let _data = { ...placementTemplatePacket };
    let _placementTemplates = _data.PlacementTemplates;
    let _newPlacementTemplates = [];
    _newPlacementTemplates.push(newPlacementTemplate);
    _placementTemplates.map((t) => {
      _newPlacementTemplates.push(t);
    });
    _data.PlacementTemplates = _newPlacementTemplates;
    dispatch(setData(_data));
  };

  return (
    <div className="card mb-5">
      <div className="card-header" style={{ backgroundColor: 'white' }}>
        <div className="d-flex">
          <h4 className="flex-grow-1 mb-0">Sensor Placement Templates</h4>
        </div>
      </div>
      <div className="card-body">
        <>
          <div>
            {loading && <AwpSpinner />}
            {loaded &&
            (!placementTemplatePacket ||
              !placementTemplatePacket.PlacementTemplates ||
              placementTemplatePacket.PlacementTemplates.length === 0) ? (
              <div>No placement templates found</div>
            ) : (
              loaded && (
                <Card>
                  <Row style={{ paddingLeft: '1.5rem' }}>
                    <Col className="pt-2 awp-sensor-placement-templates-header" md={6}>
                      <b>{'Name'}</b>
                    </Col>
                    <Col
                      style={{ paddingRight: '3rem' }}
                      className="pt-2 text-right awp-sensor-placement-templates-header"
                      md={6}
                    >
                      <b>{'Actions'}</b>
                    </Col>
                  </Row>
                  <Card.Body className="pt-2">
                    {placementTemplatePacket.PlacementTemplates.map((pt, i) => {
                      return <PlacementTemplate key={'tpl_key_' + i + ''} template={pt} />;
                    })}
                  </Card.Body>
                </Card>
              )
            )}
          </div>
        </>
      </div>
      <div className="col" style={{ display: 'flex', marginBottom: '15px' }}>
        <Authorize requires={[Permissions.WriteSensorType]}>
          <Button
            variant="primary"
            className="align-self-center"
            onClick={() => createNewTemplate()}
            disabled={isOtherEditing()}
          >
            Create New Template
          </Button>
        </Authorize>
      </div>
    </div>
  );
};

PlacementTemplateList.propTypes = {};

export default PlacementTemplateList;
